// extracted by css-extract-rspack-plugin
export default {"itemInfo":"src-pages-projects-itemMetadata-ItemMetadataDisplay-module__itemInfo-fOsvSk","itemInfoDetail":"src-pages-projects-itemMetadata-ItemMetadataDisplay-module__itemInfoDetail-_mgkqm","itemInfoPair":"src-pages-projects-itemMetadata-ItemMetadataDisplay-module__itemInfoPair-cNIz0f","itemInfoValue":"src-pages-projects-itemMetadata-ItemMetadataDisplay-module__itemInfoValue-pclEXw","itemInfoKey":"src-pages-projects-itemMetadata-ItemMetadataDisplay-module__itemInfoKey-vQUelK"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"itemInfo\":\"src-pages-projects-itemMetadata-ItemMetadataDisplay-module__itemInfo-fOsvSk\",\"itemInfoDetail\":\"src-pages-projects-itemMetadata-ItemMetadataDisplay-module__itemInfoDetail-_mgkqm\",\"itemInfoPair\":\"src-pages-projects-itemMetadata-ItemMetadataDisplay-module__itemInfoPair-cNIz0f\",\"itemInfoValue\":\"src-pages-projects-itemMetadata-ItemMetadataDisplay-module__itemInfoValue-pclEXw\",\"itemInfoKey\":\"src-pages-projects-itemMetadata-ItemMetadataDisplay-module__itemInfoKey-vQUelK\"}";
        // 1793732228628
        var cssReload = require("../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  